import { UiTypes } from "state/types/UiTypes";

export const UiActions = {};

// THUNKS
// ----------------------------------------------------------------------

UiActions.loaderHideDelay = (seconds) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(UiActions.loaderHide());
    }, (seconds || 1) * 1000);
  };
};

UiActions.publishSuccessAlert = (message) => {
  return UiActions.publishAlert("success", message, 8);
};

UiActions.publishErrorAlert = (message) => {
  return UiActions.publishAlert("error", message, 8);
};

UiActions.publishAlert = (type, message, seconds) => {
  return (dispatch) => {
    let alertId = Date.now(),
        alertData;
        
    alertData = {
      type: type || "",
      message: message,
      duration: seconds * 1000,
      id: alertId,
      messageId: alertId,
      timeoutId: setTimeout(() => {
        dispatch(UiActions.alertRemove(alertId));
      }, seconds * 1000)
    };
    
    dispatch(UiActions.alertPublish(alertData));
  };
};

UiActions.resetState = () => {
  return (dispatch) => {
    dispatch(UiActions.clearQueue());
    dispatch(UiActions.loaderHide());
    dispatch(UiActions.menuHide());
    dispatch(UiActions.notifsHide());
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

UiActions.recaptchaSet = (captcha) => ({
  type: UiTypes.recaptchaSet,
  recaptcha: captcha
});

UiActions.recaptchaUnset = () => ({
  type: UiTypes.recaptchaUnset
});

UiActions.recaptchaRequest = (status) => ({
  type: UiTypes.recaptchaRequest,
  recaptchaRequest: status
});

UiActions.setLoadingStatus = (status) => ({
  ui: {
    loading: (status === true)
  },
  type: UiTypes.loadingSet
});

UiActions.loaderHide = () => ({
  ui: {
    loader: {
      visible: false
    }
  },
  type: UiTypes.loaderHide
});

UiActions.loaderShow = (loaderType) => ({
  ui: {
    loader: {
      visible: true,
      type: (typeof loaderType === "string" && loaderType.trim() !== "") 
        ? loaderType.trim() 
        : ""
    }
  },
  type: UiTypes.loaderShow
});

UiActions.menuHide = () => ({
  ui: {
    menu: {
      visible: false
    }
  },
  type: UiTypes.menuHide
});

UiActions.menuShow = () => ({
  ui: {
    menu: {
      visible: true
    }
  },
  type: UiTypes.menuShow
});

UiActions.mobileSet = (isMobile) => ({
  ui: {
    mobile: (isMobile === true)
  },
  type: UiTypes.mobileSet
});

UiActions.notifsHide = () => ({
  ui: {
    notifs: {
      visible: false
    }
  },
  type: UiTypes.notificationsHide
});

UiActions.notifsShow = () => ({
  ui: {
    notifs: {
      visible: true
    }
  },
  type: UiTypes.notificationsShow
});

UiActions.alertPublish = (alert) => ({
  alert: alert,
  type: UiTypes.alertPublish
});

UiActions.alertRemove = (alertId) => ({
  alertId: alertId,
  type: UiTypes.alertRemove
});

UiActions.alertClear = () => ({
  type: UiTypes.alertClearAll
});

UiActions.queue = (queueId) => ({
  queueId: queueId,
  type: UiTypes.queue
});

UiActions.dequeue = (queueId) => ({
  queueId: queueId,
  type: UiTypes.dequeue
});

UiActions.clearQueue = () => ({
  type: UiTypes.clearQueue
});

UiActions.setFeedbackFormId = (currentFeedbackFormId) => ({
  ui: {
    currentFeedbackFormId: currentFeedbackFormId
  },
  type: UiTypes.setFeedbackFormId
});

UiActions.beautyProfileToggle = () =>{
  return {
    type: UiTypes.beautyProfileToggle
  }
}
